// extracted by mini-css-extract-plugin
export default {"root":"LzSpR","llama":"_3hkQ-","big":"_3UBjx","small":"_2vFwy"};